module.exports = __webpack_public_path__ + "img/img30.d9c76d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img30.png
// module id = 374
// module chunks = 0